export default function id() {
  return Math.random().toString(36).substr(2, 9);
}



// WEBPACK FOOTER //
// ./src/components/ids.js